<app-navbar />
<main>
  <router-outlet></router-outlet>
  <p-toast position="top-right"></p-toast>
</main>
<app-loading-spinner />
